import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initialState = {
    updateCost:''
};

export const updateCostConfig = {
  name: "Update Cost",
  initialState: initialState,
  section: [
    {
      sectionId: "updateCostSection",
      title: "Update Cost Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className=""></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "updateCost",
          label: "Update Cost :",
          Field_Name: "updateCost",
          fieldType: FormFieldTypes.INPUT,
          dataField: "updateCost",
          fieldSetting: {
            placeholder: "Enter Cost",
            isEnableOnChange: true,
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        }
      ],
    },
  ],
};
